// Escucha el evento que la app Tonica B2B dispara con el total de resultados
// que oculto de la busqueda (por reglas de "Catalogo por coleccion"). Corrige
// los contadores de cantidad de productos ("110 articulos", "Ver 110
// articulos") para que reflejen lo que el cliente realmente ve, no el total
// crudo de Shopify.
(function tonicaSearchCountFix() {
  var ORIGINAL_ATTR = 'data-tonica-original-count';

  function countElements() {
    return document.querySelectorAll(
      '[title="Recuento de productos"], .facets__see-results'
    );
  }

  function correctElement(el, hiddenCount) {
    var original = el.getAttribute(ORIGINAL_ATTR);
    if (original === null) {
      var match = (el.textContent || '').match(/\d+/);
      if (!match) return;
      original = match[0];
      el.setAttribute(ORIGINAL_ATTR, original);
    }
    var corrected = Math.max(0, parseInt(original, 10) - hiddenCount);
    el.textContent = el.textContent.replace(/\d+/, String(corrected));
  }

  document.addEventListener('tonica:b2b:search-results-count-changed', function (event) {
    var hiddenCount = (event.detail && event.detail.hiddenCount) || 0;
    if (!hiddenCount) return;
    countElements().forEach(function (el) {
      correctElement(el, hiddenCount);
    });
  });
})();
